import React, { useEffect, useState } from "react";
import { routes } from "../../helpers/router.helper";
import { SubCategoryListController } from "../SubCategoryList";
import { ISubcategory } from "../../../../shared/interface/subcategory";
import { Accordions, IAccordion } from "./Accordion";

interface IAccordionControllerProps {
  subcategories: ISubcategory[];
  category: string;
}

export const AccordionController = ({
  subcategories,
  category,
}: IAccordionControllerProps) => {
  const [accordions, setAccordions] = useState<IAccordion[]>([]);

  useEffect(() => {
    const mapped = subcategories.map((subCategory, index) => ({
      label: subCategory.name,
      href: routes.subcategory(category, subCategory.uri),
      child: (
        <SubCategoryListController
          categorySlug={category}
          subcategorySlug={subCategory.uri}
          data-id={`sub-accordion-${index}`}
        />
      ),
    }));
    setAccordions([...mapped]);
  }, [subcategories, category]);

  return <Accordions accordions={accordions} />;
};
